import { useParams } from 'react-router-dom';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';

const useResources = () => {
  const { runRequest } = useRunRequest();
  const { id: workerId } = useParams<{ id: string }>();

  const logSSNCopy = async () => {
    await runRequest({
      fetchType: 'CREATE',
      resource: TurnResourcesEnum.FcraWorkers,
      mode: 'silent',
      params: {
        id: workerId,
        target: TurnTargetsEnum.Events,
        data: { event_key: 'copy_ssn_clicked' },
      },
    });
  };

  return {
    logSSNCopy,
  };
};

export default useResources;
